// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2W7Wa","footerInContainer":"Footer_footerInContainer__hAZSd","btnWrapper":"Footer_btnWrapper__ANZXI"};